import { render, staticRenderFns } from "./CompanyVerify.vue?vue&type=template&id=1dd5bff6&scoped=true"
import script from "./CompanyVerify.vue?vue&type=script&lang=js"
export * from "./CompanyVerify.vue?vue&type=script&lang=js"
import style0 from "./CompanyVerify.vue?vue&type=style&index=0&id=1dd5bff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd5bff6",
  null
  
)

export default component.exports